<div style="display:none">{{fields[0].props.changeDetect|async}}</div>
  <div #rootContainer [formGroup]="componentForm" style="padding: 4px;" class="control-attributes active-control">
  <img src="/assets/SignHere.png">
</div>
